import React from 'react';
import classnames from 'classnames/bind';

import { Button } from 'components/Button/Button';

import Row, { emptyRow } from './JsonObjectInputRow';
import {
  deserializeJsonObjectValues,
  serializeJsonObjectValues,
} from './serialize';
import { validateAreKeysUnique } from './validate';
import { JsonObjectInputRowField } from './RowField';
import styles from './JsonObjectInput.module.scss';

const c = classnames.bind(styles);

export type JsonObjectInputProps = {
  value: object;
  onChange: (value: Record<string, string>) => void;
  disabled?: boolean;
};

export function JsonObjectInput({
  value: initialValues,
  onChange,
  disabled = false,
}: JsonObjectInputProps) {
  const [rows, setRows] = React.useState<Row[]>(
    deserializeJsonObjectValues(initialValues)
  );

  const errorRows = React.useMemo(() => validateAreKeysUnique(rows), [rows]);

  function handleAddClick() {
    if (disabled) {
      return;
    }

    const newRows = [...rows, emptyRow];
    setRows(newRows);
    onChange(serializeJsonObjectValues(newRows));
  }

  function handleRowChange(row: Row, index: number) {
    const newRows = [...rows.slice(0, index), row, ...rows.slice(index + 1)];
    setRows(newRows);
    onChange(serializeJsonObjectValues(newRows));
  }

  return (
    <fieldset className={c('wrap')}>
      {rows.map((row, index) => (
        <JsonObjectInputRowField
          id={`row_${index}`}
          error={errorRows.includes(index)}
          value={row}
          onChange={(row) => handleRowChange(row, index)}
          disabled={disabled}
          key={index}
        />
      ))}
      <Button
        className={c('button')}
        variant="secondary"
        onClick={handleAddClick}
        size="small"
        disabled={disabled}
      >
        Add parameter
      </Button>
    </fieldset>
  );
}
